export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons-react/es/index.js
// module id = 527
// module chunks = 0